import React, { FC } from 'react'

const CircleWarningIcon: FC = () => (
  <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 13.3333C0 5.96953 5.96954 0 13.3333 0C20.6971 0 26.6667 5.96954 26.6667 13.3333C26.6667 20.6971 20.6971 26.6667 13.3333 26.6667C5.96953 26.6667 0 20.6971 0 13.3333ZM14.6667 18.6665V18.665C14.6667 17.9286 14.0697 17.3317 13.3333 17.3317C12.597 17.3317 12 17.9286 12 18.665V18.6665C12 19.4029 12.597 19.9998 13.3333 19.9998C14.0697 19.9998 14.6667 19.4029 14.6667 18.6665ZM14.6667 14.165V8.83167C14.6667 8.09529 14.0697 7.49834 13.3333 7.49834C12.597 7.49834 12 8.09529 12 8.83167V14.165C12 14.9014 12.597 15.4983 13.3333 15.4983C14.0697 15.4983 14.6667 14.9014 14.6667 14.165Z"
      fill="currentColor"
    />
  </svg>
)

export default CircleWarningIcon
